import * as XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

export function createCSVFile(headers: string[], rows: string[][], filename: string) {
  const csvContent = [headers.join(','), ...rows.map((row) => row.map((cell) => `"${String(cell).replace(/"/g, '""')}"`).join(','))].join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  return { url, filename: `${filename}.csv` };
}

export function createExcelFile(headers: string[], rows: string[][], filename: string) {
  const wsData = [headers, ...rows];
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet(wsData);
  const colWidths = headers.map((_, colIndex) => {
    const maxLength = Math.max(
      headers[colIndex].length,
      ...rows.map((row) => String(row[colIndex] || '').length)
    );
    return { wch: Math.min(maxLength + 2, 50) };
  });
  ws['!cols'] = colWidths;
  XLSX.utils.book_append_sheet(wb, ws, 'Report');
  const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([excelBuffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = URL.createObjectURL(blob);
  return { url, filename: `${filename}.xlsx` };
}

export function createPDFFile(
  headers: string[],
  rows: string[][],
  filename: string,
  options?: { title?: string }
) {
  const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
  doc.setFontSize(11);
  doc.text(options?.title ?? 'Report', 14, 12);
  autoTable(doc, {
    head: [headers],
    body: rows.length > 0 ? rows : [headers.map(() => '')],
    startY: 18,
    styles: { fontSize: 7, cellPadding: 1.5 },
    headStyles: { fillColor: [60, 60, 60] },
    margin: { left: 14, right: 14 },
  });
  const blob = doc.output('blob');
  const url = URL.createObjectURL(blob);
  return { url, filename: `${filename}.pdf` };
}
